import { getEnvSegment } from 'src/utils/env'

import type { CacheKeyParts } from './types'

// `languageCode` is lower-cased to match `buildCrdtChannelName`; otherwise an
// `EN`/`en` mismatch would write the same backend channel to two cache rows.
export const buildCacheKey = ({ jobId, languageCode }: CacheKeyParts): string => `${getEnvSegment()}:${jobId}:${languageCode.toLowerCase()}`
